import React from "react";

export default function CardHead({ icon, title, subtitle, children, onClick }) {
  return (
    <div className="card-head">
      <div>
        <div className="card-title">{title}</div>
        {subtitle && (
          <div
            className="card-sub"
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            {subtitle}
          </div>
        )}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {children}
        <button className="btn-icon" onClick={onClick}>
          <i className="fas fa-download" style={{ fontSize: ".7rem" }}></i>
        </button>
      </div>
    </div>
  );
}
